import { render, staticRenderFns } from "./BrandPrice.vue?vue&type=template&id=1004fff1&scoped=true"
import script from "./BrandPrice.vue?vue&type=script&lang=js"
export * from "./BrandPrice.vue?vue&type=script&lang=js"
import style0 from "./BrandPrice.vue?vue&type=style&index=0&id=1004fff1&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1004fff1",
  null
  
)

export default component.exports